import { z } from "zod";

export const ErrorResponse = z.object({
    code: z.number(),
    message: z.string(),
    success: z.boolean(),
})

export type ErrorResponse = z.infer<typeof ErrorResponse>;